import { clientAndIdentityPageRoute } from './ClientAndIdentityPage/route';
import { clientBankProductsAndServicesRoute } from './ClientBankProductsAndServicesPage/route';
import { clientRequirementsRoute } from './route';

export const clientRequirementsRoutes = clientRequirementsRoute.addChildren([
	clientAndIdentityPageRoute,
	clientBankProductsAndServicesRoute,
]);
